/* eslint no-underscore-dangle: 0 */
import * as Blockly from 'blockly/core';


export const moveWorkspaceBy = (workspace, dx = 0, dy = 0) => {
  if (workspace) {
    const metrics = workspace.getMetrics();
    if (metrics && workspace.scrollbar) {
      let a = dx;
      let b = dy;
      a = Math.min(a, -metrics.contentLeft);
      b = Math.min(b, -metrics.contentTop);
      a = Math.max(a, metrics.viewWidth - metrics.contentLeft - metrics.contentWidth);
      b = Math.max(b, metrics.viewHeight - metrics.contentTop - metrics.contentHeight);
      workspace.scrollbar.set(a - metrics.contentLeft, b - metrics.contentTop)
    }
  }
};

export const resizeWorkspace = (workspace, containerId = 'blocklyContainer') => {
  const blocklyContainer = document.getElementById(containerId);
  if (blocklyContainer) {
    const blocklyArea = blocklyContainer.parentElement;
    // El contenedor es position:absolute: left/top van relativos a su
    // offsetParent, no al documento (dentro de .blocklyPanel quedaría corrido).
    const containingBlock = blocklyContainer.offsetParent;
    let element = blocklyArea;
    let x = 0;
    let y = 0;
    while (element && element !== containingBlock) {
      x += element.offsetLeft;
      y += element.offsetTop;
      element = element.offsetParent;
    }
    blocklyContainer.style.left = `${x}px`;
    blocklyContainer.style.top = `${y}px`;
    blocklyContainer.style.width = `${blocklyArea.offsetWidth}px`;
    blocklyContainer.style.height = `${blocklyArea.offsetHeight}px`;
    Blockly.svgResize(workspace);
  }
};

// El flyout horizontal arranca corrido (x≈148) para dejar libre el botón de
// ejecutar; se corre solo el flyout, no #blocklyContainer. Blockly lo reposiciona
// varias veces por resize, así que un MutationObserver reaplica el offset (el
// chequeo contra `offsetX` evita el loop).
export const keepHorizontalFlyoutOffset = (workspace, offsetX) => {
  const flyout = workspace?.getFlyout?.();
  const flyoutSvg = flyout?.svgGroup_;
  if (!flyoutSvg || flyoutSvg.dataset.rb123FlyoutOffset) return;
  flyoutSvg.dataset.rb123FlyoutOffset = '1';

  const parse = () => {
    const current = flyoutSvg.getAttribute('transform') || flyoutSvg.style.transform || '';
    // La v13 escribe style.transform con "px"; el regex tolera el sufijo opcional.
    const match = current.match(/translate\(([-\d.]+)px?[,\s]+([-\d.]+)px?\)/);
    return match ? { x: parseFloat(match[1]), y: match[2] } : null;
  };

  // No achicar acá el `width` del svg del flyout: el scrollbar no lo lee y no
  // llega al último bloque. Los 148px se restan en `JuniorHorizontalFlyout.getWidth()`.
  const apply = () => {
    const parsed = parse();
    if (!parsed || parsed.x >= offsetX) return;
    const newX = parsed.x + offsetX;
    if (flyoutSvg.hasAttribute('transform')) {
      flyoutSvg.setAttribute('transform', `translate(${newX}, ${parsed.y})`);
    } else {
      flyoutSvg.style.transform = `translate(${newX}px, ${parsed.y}px)`;
    }
  };

  apply();
  const observer = new MutationObserver(apply);
  observer.observe(flyoutSvg, { attributes: true, attributeFilter: ['style', 'transform'] });
};

// `resizeWorkspace` NO debe llamar a `moveWorkspaceBy(workspace, 0, 0)`: corre el
// scroll a (8, 8) y el bloque inicial queda con el doble de margen que en prod.
